import React from 'react';

interface ModalProps {
  title: string;
  children: React.ReactNode;
  onClose: () => void;
  isOpen?: boolean;
  size?: 'sm' | 'md' | 'lg' | 'xl';
  fullPage?: boolean;
  minHeight?: string | number;
  height?: string | number;
}

const Modal: React.FC<ModalProps> = ({ title, children, onClose, isOpen = true, size = 'md', fullPage = false, minHeight, height }) => {
  if (!isOpen) return null;

  const modalSizeClass = fullPage ? 'modal-full-page' : size ? `modal-${size}` : '';
  
  const modalStyle: React.CSSProperties = {};
  if (height) {
    modalStyle.height = typeof height === 'number' ? `${height}px` : height;
  }
  if (minHeight) {
    modalStyle.minHeight = typeof minHeight === 'number' ? `${minHeight}px` : minHeight;
  }

  return (
    <div className={fullPage ? 'modal-overlay modal-overlay-full-page' : 'modal-overlay'} onClick={onClose}>
      <div className={`modal ${modalSizeClass}`} onClick={(e) => e.stopPropagation()} style={modalStyle}>
        <div className="modal-header">
          <h3 className="modal-title">{title}</h3>
          <button className="modal-close" onClick={onClose}>
            ×
          </button>
        </div>
        <div className="modal-body">
          {children}
        </div>
      </div>
    </div>
  );
};

export default Modal;